// extracted by mini-css-extract-plugin
export var body = "g_B";
export var footer = "g_D";
export var header = "g_z";
export var network = "g_C";